var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"hero is-medium"},[_c('div',{staticClass:"hero-body has-text-centered"},[_c('b-icon',{attrs:{"icon":"shield-lock","size":"is-large","type":"is-warning"}}),_c('h1',{staticClass:"title mt-4"},[_vm._v("Acesso ao PDV não liberado")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }